export default "__VITE_ASSET__WP8KmeRn__"